import { useMemo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResource } from "types/generated";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectResourcesTableTypeCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<IntentResource>) => {
  const copyAction = useCellCopyAction({
    text: resource.resourceType,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellText>{resource.resourceType}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntentProjectResourcesTableTypeCell;
